<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductSalesLettersModalEditExternalSite.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modal section"
        class="m-the-modal-section-height-auto"
      >
        <AtomInputPrimary
          v-model="carta.nombre"
          :inputError="$v.carta.nombre.$error"
          :label="$t('mEditionProductSalesLettersModalEditExternalSite.inputs.nombre.label')"
          :message="$t('mEditionProductSalesLettersModalEditExternalSite.inputs.nombre.message')"
          :messageError="messageErrorNombre"
          name="nombre"
          :placeholder="$t('mEditionProductSalesLettersModalEditExternalSite.inputs.nombre.placeholder')"
          type="text"
          @blur="$v.carta.nombre.$touch()"
        />
        <AtomInputPrimary
          v-model="carta.url"
          :inputError="$v.carta.url.$error"
          :label="$t('mEditionProductSalesLettersModalEditExternalSite.inputs.url.label')"
          :messageError="messageErrorUrl"
          name="url"
          :placeholder="$t('mEditionProductSalesLettersModalEditExternalSite.inputs.url.placeholder')"
          type="text"
          @blur="$v.carta.url.$touch()"
        />
        <p class="font-weight-light">
          {{ $t('mEditionProductSalesLettersModalEditExternalSite.productUrlFormMessage') }}
        </p>
        <p>
          <a
            class="font-weight-bold text-link-hover-products"
            :href="productUrlForm"
            target="_blank"
          >
            {{ productUrlForm }}
          </a>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductSalesLettersModalEditExternalSite.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required, url } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionProductSalesLettersModalEditExternalSite',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductSalesLettersModalEditExternalSite.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      },

      carta: {
        nombre: this.$modal.element.carta.nombre,
        url: this.$modal.element.carta.url
      },

      productUrlForm: ''
    }
  },

  validations: {
    carta: {
      nombre: {
        maxLength: maxLength(60),
        minLength: minLength(1),
        required
      },

      url: {
        required,
        url
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionProductSalesLettersModalEditExternalSite', this.$v.carta.nombre, 'nombre')
    },

    messageErrorUrl () {
      return this.$validation.getValidationMessage('mEditionProductSalesLettersModalEditExternalSite', this.$v.carta.url, 'url')
    }
  },

  created () {
    this.productUrlForm = `${this.$utils.getMarketPlaceDomain()}/${this.$store.getters.getAcademyData.url}/producto/${this.$route.params.id}/comprar`
  },

  methods: {
    updateProductoPaginaIdroop () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('producto', 'updateProductoPaginaIdroop', this.carta, [this.$modal.element.carta.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductSalesLettersModalEditExternalSite', 'updateProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductSalesLettersModalEditExternalSite', 'updateProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
